import React, { useState } from "react";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { getMoraTotalAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";

const MoraTotal = () => {
  const [mora, setMora] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getMoraTotalAsync,
    (data) => setMora(data.result ?? 0)
  );

  return (
    <KpiPanel
      titulo="Mora Total"
      valor={mora}
      formato="monto"
      icono={<TrendingDownIcon />}
      tono="error"
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino="/credits"
      permiso="CREDITS VER"
      ayuda="Ver Créditos"
    />
  );
};

export default MoraTotal;
